 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLSERIES from '@/components/xhtml/series'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLILL from '@/components/xhtml/ill'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLABB from '@/components/xhtml/abb'
 import XHTMLOTHER from '@/components/xhtml/other'
 import XHTMLCHAPTER0 from '@/components/xhtml/chapter0'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLESSAY from '@/components/xhtml/essay'
 import XHTMLINDEX from '@/components/xhtml/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/ill",
 			"name" : "xhtml/ill",
 			"component" : XHTMLILL
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/abb",
 			"name" : "xhtml/abb",
 			"component" : XHTMLABB
 		},
 		{
 			"path" : "/xhtml/other",
 			"name" : "xhtml/other",
 			"component" : XHTMLOTHER
 		},
 		{
 			"path" : "/xhtml/chapter0",
 			"name" : "xhtml/chapter0",
 			"component" : XHTMLCHAPTER0
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js